import script from "./CastomSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CastomSelect.vue?vue&type=script&setup=true&lang=js"

import "./CastomSelect.vue?vue&type=style&index=0&id=0b463255&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b463255"]])

export default __exports__